// src/Invoice/UnassignedRecordNumbersOverview.tsx
import React, { useMemo, useState } from 'react';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import { DataGrid, deDE, GridColDef } from '@mui/x-data-grid';
import { LoadingSpinner } from '../core/LoadingSpinner';
import { NoDataContenct } from '../core/NoDataContenct';
import { Link as LinkIcon } from '@mui/icons-material';
import { useGetUnassignedRecordNumbers } from '../hooks/reactQuerys/InvoiceQueries';
import { filterUnassignedRecordNumbers } from './unassignedRecordNumberSearch';

export const UnassignedRecordNumbersOverview: React.FC = () => {
  const {
    unassignedRecordNumbers: data,
    isLoadingUnassignedRecordNumbers: isLoading,
    refetchUnassignedRecordNumbers: refetch,
  } = useGetUnassignedRecordNumbers();

  // #1186: Suche nach Aktenzeichen und Vorgangsnummer (client-seitig).
  const [searchTerm, setSearchTerm] = useState('');
  const filteredRows = useMemo(
    () => filterUnassignedRecordNumbers(data ?? [], searchTerm),
    [data, searchTerm]
  );

  const columns: GridColDef[] = [
    { field: 'idLegalTransactionRecordNumber', headerName: 'ID', width: 110 },
    { field: 'RecordNumberEntry', headerName: 'Aktenzeichen', width: 260 },
    { field: 'idLegalTransaction', headerName: 'Vorgangsnummer', width: 130 },
    {
      field: 'Action',
      headerName: 'Aktionen',
      width: 140,
      sortable: false,
      filterable: false,
      renderCell: params => (
        <>
          <IconButton
            size='small'
            title='Rechtsgeschäft öffnen'
            component='a'
            href={`/legaltransaction/${params.row.idLegalTransaction}`}
            target='_blank'
            onClick={e => e.stopPropagation()}
          >
            <LinkIcon fontSize='small' />
          </IconButton>
        </>
      ),
    },
  ];

  if (isLoading) return <LoadingSpinner />;
  if (!data) return <NoDataContenct refetch={() => refetch()} />;

  return (
    <>
      <Typography variant='h4' sx={{ mb: 2 }}>
        Unbewertete Urkunden
      </Typography>

      <Box sx={{ mb: 2, width: { xs: '100%', sm: 420 } }}>
        <TextField
          fullWidth
          size='small'
          label='Suche (Aktenzeichen, Vorgangsnummer)'
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </Box>

      <Box>
        <DataGrid
          autoHeight
          localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
          rows={filteredRows}
          columns={columns}
          getRowId={row => row.idLegalTransactionRecordNumber}
          disableRowSelectionOnClick
        />
      </Box>
    </>
  );
};
